const ChevronSelectorInvertedVertical = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="chevron-selector-vertical">
      <path
        id="Icon"
        d="M4.66699 3L8.00033 6.33333L11.3337 3M4.66699 13L8.00033 9.66667L11.3337 13"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default ChevronSelectorInvertedVertical;
